const DIMENSIONS_TYPES = {
  'du': 'unit',
  'dw': 'width',
  'dh': 'height'
}

export function getInlineSize (svgElement = document.getElementById('svgcontent')) {
  return [...svgElement.classList].reduce((acc, className) => {
    const [property, value] = className.split('-');
    const dimensionType = DIMENSIONS_TYPES[property];
    const isUnit = dimensionType === DIMENSIONS_TYPES.du;

    // Take first class dimension values if multiple are found
    if (dimensionType && !acc[dimensionType]) {
      acc[dimensionType] = isUnit ? value : parseFloat(value);
    }

    return acc;
  }, {});
}
